export const getOptionValueLabel = (optionValue = {}) => optionValue.label || optionValue.name

export const getOptionValueValue = (optionValue = {}) =>
  optionValue.value || optionValue.presentation || ''
